<template>
  <!-- Type heading + blurb above a group of course cards (Figma 1123-86923). -->
  <div class="courses-section-heading">
    <p class="courses-section-heading__title">{{ title }}</p>
    <p v-if="description" class="courses-section-heading__text">{{ description }}</p>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CoursesSectionHeading',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  }
});
</script>

<style lang="scss" scoped>
.courses-section-heading {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: Arial, sans-serif;

  &__title {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    color: var(--asu-grayscale-gray-1, #191919);
  }

  &__text {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: var(--asu-grayscale-gray-2, #484848);
  }
}
</style>
